var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.FormMemberships)?_c('div',[(_vm.FormMemberships)?_c('NewDocument',{attrs:{"chart-record-id":_vm.ChartRecordId,"form-memberships-import":_vm.FormMemberships,"NewDocPayload":_vm.NewDocPayload}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }